import React, { PureComponent } from 'react';
import MasterAppForm from './Form/index.js';
import MessageCard from '../../components/Cards/MessageCard.js';
import Loader from '../../components/Loader.js';
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';
class MasterApplication extends PureComponent {
  state = {
    masterAppData: null
  };
  async componentDidMount() {
    const masterAppData = await this.props.getMasterApplicationData(this.props.currentAccountMeta.accountID);
    this.setState({
      masterAppData
    });
  }
  render() {
    const {
      currentAccountMeta,
      plan,
      setSelectedSection,
      isReadOnly
    } = this.props;
    if (!this.state.masterAppData || this.props.loader?.isLoading && this.props.loader?.type === 'container') {
      return /*#__PURE__*/React.createElement(Loader, {
        isContainer: true
      });
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, isReadOnly && !this.props.sendRequestApprovalLink && /*#__PURE__*/React.createElement(MessageCard, {
      title: i18n.t(tokens.labels.masterApplication.readOnlyMode),
      subtitle: i18n.t(tokens.labels.masterApplication.readOnlyModeMessage)
    }), /*#__PURE__*/React.createElement(MasterAppForm, {
      whitelabel: this.props.whitelabel,
      currentAccountMeta: currentAccountMeta,
      data: this.state.masterAppData,
      plan: plan,
      isMasterSite: this.props.isMasterSite,
      setSelectedSection: setSelectedSection,
      isReadOnly: isReadOnly,
      updateMasterApp: this.props.updateMasterApp,
      completeMasterApp: this.props.completeMasterApp,
      sendRequestApprovalLink: this.props.sendRequestApprovalLink,
      displayError: this.props.displayError,
      isPrivateLabelAdvisor: this.props.isPrivateLabelAdvisor
    }));
  }
}
export default MasterApplication;